/* eslint-disable no-undef */
import 'core-js/stable';
import { reportWebVitals } from 'src/utils/reportWebVitals';
import { App } from 'src/App';
import { unregister } from 'src/registerServiceWorker';
import { isDevEnv } from 'src/utils/isDevEnv';
import { initDatadog } from './config/datadog';
import {
  setTag,
  setupGlobalErrorHandling,
} from 'src/utils/datadogErrorHandling';
import React from 'react';
import ReactDOM from 'react-dom';
import {
  appModeUuid,
  release,
  buildVersion,
  environment,
} from 'src/utils/capabilities';
import 'src/utils/intercom';
import './polyfills';

const isDev = isDevEnv();
const isOktetoEnv = !!import.meta.env.OKTETO;

if (!isDev && !isOktetoEnv) {
  initDatadog();

  setupGlobalErrorHandling();

  setTag('release', release);
  setTag('application_mode_uuid', appModeUuid);
  setTag('environment', environment || 'beta');
  setTag('build_version', buildVersion);
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

unregister();
reportWebVitals();
